import React from 'react';
import { Box, Group, Paper, Text, Title, useMantineTheme } from '@mantine/core';
import { FallbackIcon } from './FallbackIcon';
import { FallbackType } from "@shared-types/auth.types.ts";
import { FallbackContentProps } from './FallbackContent';

export function SectionFallback({title, action, role, icon}: Omit<FallbackContentProps, 'type'>): React.ReactElement {
  const theme = useMantineTheme();

  return (
    <Box>
      {title && (
        <Title order={2} mb={16}>{title}</Title>
      )}
      <Paper

        radius="md"
        p="xl"
        shadow="sm"
        style={{
          textAlign: 'center',
          transition: 'all 0.3s ease'
        }}
      >
        <Group justify="center" mb="md">
          <Box style={{color: theme.colors.gray[6]}}>
            <FallbackIcon type={FallbackType.Section} customIcon={icon}/>
          </Box>
        </Group>
        <Text size="lg" c="dimmed" fw={500}>
          {role} role or higher required to {action}
        </Text>
        <Text size="sm" c="dimmed" mt="xs">
          Contact your administrator to request access
        </Text>
      </Paper>
    </Box>
  );
}